<script setup lang="ts">
import { ConcreteComponent } from "vue/dist/vue";
import { parseContent } from "~/utils/kentico/ContentParser";
import { toPascalCase } from "~/utils/stringUtils";
import { IKenticoResponse } from "~/types/kentico/content";

const route = useRoute();

export interface IKenticoContentProps {
	kenticoResponse: IKenticoResponse | undefined;
	defaultComponent?: string;
}

const props = withDefaults(defineProps<IKenticoContentProps>(), {
	defaultComponent: "KenticoComponentsCustomContent",
});

const parsedContent = computed(() => parseContent(props.kenticoResponse?.content, { applyBindings: true }));

const renderView: ConcreteComponent | boolean = computed(() => {
	if (!parsedContent.value) return false;
	const instance = getCurrentInstance();
	const compToResolve = toPascalCase(parsedContent.value.componentName);
	if (route.path.includes("how-to-")) {
		const componentName = "KenticoComponentsHowTos";
		return resolveComponent(componentName);
	}
	if (route.path.includes("contact")) {
		const componentName = "KenticoComponentsContact";
		return resolveComponent(componentName);
	}
	const componentName =
		typeof instance?.appContext.components === "object" && compToResolve in instance.appContext.components ? compToResolve : props.defaultComponent;

	return resolveComponent(componentName);
});
</script>

<template>
	<NuxtErrorBoundary>
		<component
			v-if="renderView"
			:is="renderView"
			:content="parsedContent?.content"
			:scripts="parsedContent?.scripts"
			:node="parsedContent?.node"
			:key="parsedContent?.node"
			:styles="parsedContent?.styles"
			:noHeader="route.path === '/leaderboard'"
		></component>
	</NuxtErrorBoundary>
</template>
